export default __webpack_public_path__ + "static/media/cloud_infrastructure.20b580f8.svg";